module.exports = __webpack_public_path__ + "static/img/Boss_31091.164267c0.png";